import React, { useEffect, useState } from 'react';

const LoginContext = React.createContext({});

// Verificar si ya existe información en localStorage y cargarla
export const dataLogin = localStorage.getItem("infoUser")
    ? JSON.parse(localStorage.getItem("infoUser"))
    : {
        isLoged: false,
        usuario: "unknow",
        firma: "unknow",
    };

export function LoginContextProvider({ children }) {
    const [infoUser, setInfoUser] = useState(dataLogin);

    // Actualizar el localStorage cuando `infoUser` cambie
    useEffect(() => {
        console.log("Setting infoUser in localStorage");
        localStorage.setItem("infoUser", JSON.stringify(infoUser));
    }, [infoUser]);

    return (
        <LoginContext.Provider value={{ infoUser, setInfoUser }}>
            {children}
        </LoginContext.Provider>
    );
}

export default LoginContext;
